import {Modal} from '../index';
import {useDispatch} from 'react-redux';
import {closeModuleModal} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation';

export default ({modal, data}) => {
    const dispatch = useDispatch();

    return (
        <Modal>
            <div className="header">
                <div className="title">Cashout completed</div>
                <div className="close" onClick={e => dispatch(closeModuleModal())}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18 18L6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>

            <div className="creative">
                <img src={`${window.location.origin}/source/modules/modals/cashout_success/creative.png`} />
            </div>

            <div className="banner-invite" onClick={e => {
                dispatch(closeModuleModal());
                navigate('/invite');
            }}>
                <div className="banner-details">
                    <div className="banner-block">
                        <div className="banner-title">Earn More Money</div>
                        <div className="banner-text">Invite friends and get rewarded when they deposit.</div>
                    </div>
                    <div className="banner-link">
                        Start Earning

                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.41748 3.45917L11.9583 7L8.41748 10.5408"
                                stroke="white"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path d="M2.0415 7H11.859" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div className="banner-creative">
                    <div className="creative"></div>
                </div>
            </div>

            <div className="payment-details">
                <div className="detail">
                    <div className="label">Payment ID</div>
                    <div className="value">{modal.details.payment.paymentId}</div>
                </div>
                <div className="detail">
                    <div className="label">Method</div>
                    <div className="value">
                        {
                            modal.details.payment.method === 'chime'
                            ? (
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_4736_10006)">
                                        <rect width="36" height="36" rx="18" fill="#1EC576" />
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4225 0C27.0375 0 28.8366 2.02656e-06 30.8024 0.616669C31.8519 1 32.8015 1.6 33.6011 2.4C34.4007 3.2 35.0005 4.15 35.3836 5.2C36 7.15 36 8.95 36 12.5667V23.4333C36 27.0333 36 28.85 35.3836 30.8C35.0005 31.85 34.4007 32.8 33.6011 33.6C32.8015 34.4 31.8519 35 30.8024 35.3833C28.8533 36 27.0541 36 23.4392 36H12.5442C8.94586 36 7.13003 36 5.18093 35.3833C4.13142 35 3.18186 34.4 2.38223 33.6C1.5826 32.8 0.982879 31.85 0.599723 30.8C3.9718e-07 28.85 0 27.0667 0 23.4333V12.55C0 8.95 1.19154e-07 7.13333 0.616381 5.18333C0.999537 4.13333 1.59926 3.18333 2.39889 2.38333C3.19852 1.58333 4.14808 0.983334 5.19759 0.600001C7.13003 1.03315e-06 8.94586 0 12.5442 0H23.4225Z"
                                            fill="#1EC576"
                                        />
                                        <g clip-path="url(#clip1_4736_10006)">
                                            <path
                                                d="M19.182 26.1143C21.9128 26.1143 23.848 25.0823 24.9998 24.2163V20.4557C23.3019 21.7962 21.3073 22.5673 19.5382 22.5673C16.7125 22.5673 14.7297 20.6218 14.7297 17.8221C14.7297 15.1648 16.5344 13.3142 19.1108 13.3142C19.9538 13.3142 20.678 13.5277 21.4498 13.7413C22.2453 13.9666 23.0764 14.2158 24.0618 14.2158C24.3705 14.2158 24.6791 14.192 24.9879 14.1446V10.562C24.7267 10.5857 24.4773 10.6094 24.2161 10.6094C23.3257 10.6094 22.5183 10.4433 21.6753 10.2654C20.7849 10.0756 19.8707 9.88579 18.7902 9.88579C16.6413 9.88579 14.6466 10.645 13.1862 12.0449C11.6309 13.5277 10.7998 15.5919 10.7998 18C10.7998 22.7809 14.2429 26.1143 19.182 26.1143Z"
                                                fill="white"
                                            />
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4736_10006">
                                            <rect width="36" height="36" rx="18" fill="white" />
                                        </clipPath>
                                        <clipPath id="clip1_4736_10006">
                                            <rect width="14.2" height="16.2285" fill="white" transform="translate(10.7998 9.88579)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            ) : (
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M30.6176 -23.625C38.9426 -23.625 43.1051 -23.625 47.6578 -22.1941C52.6008 -20.373 56.373 -16.6008 58.1941 -11.6578C59.625 -7.10508 59.625 -2.94258 59.625 5.38242V30.6176C59.625 38.9426 59.625 43.1051 58.1941 47.6578C56.373 52.6008 52.6008 56.373 47.6578 58.1941C43.1051 59.625 38.9426 59.625 30.6176 59.625H5.38242C-2.94258 59.625 -7.10508 59.625 -11.6578 58.1941C-16.6008 56.373 -20.373 52.6008 -22.1941 47.6578C-23.625 43.1051 -23.625 38.9426 -23.625 30.6176V5.38242C-23.625 -2.94258 -23.625 -7.10508 -22.1941 -11.6578C-20.373 -16.6008 -16.6008 -20.373 -11.6578 -22.1941C-7.10508 -23.625 -2.94258 -23.625 5.38242 -23.625H30.6176Z"
                                        fill="#00D632"
                                    />
                                    <path
                                        d="M22.2335 14.3325C22.444 14.5433 22.7808 14.5433 22.9913 14.3325L24.0438 13.2365C24.2544 13.0258 24.2544 12.6464 24.0017 12.4356C23.1597 11.719 22.2335 11.171 21.181 10.8337L21.5178 9.23185C21.602 8.89461 21.3073 8.55737 20.9705 8.55737H18.9496C18.697 8.55737 18.4444 8.72599 18.4023 9.02107L18.1076 10.4543C15.4132 10.5808 13.0976 11.9719 13.0976 14.7962C13.0976 17.2412 14.9922 18.2951 17.013 19.0117C18.9075 19.7283 19.918 20.0234 19.918 21.0351C19.918 22.089 18.9075 22.7213 17.434 22.7213C16.0868 22.7213 14.6553 22.2576 13.5607 21.1616C13.3502 20.9508 13.0134 20.9508 12.8029 21.1616L11.6662 22.2998C11.4557 22.5105 11.4557 22.8899 11.6662 23.1007C12.5503 23.9859 13.687 24.6183 14.9501 24.9555L14.6553 26.4731C14.5711 26.8103 14.8237 27.1475 15.2027 27.1475H17.2656C17.5182 27.1475 17.7708 26.9789 17.8129 26.6838L18.1076 25.2506C21.3494 25.0398 23.3702 23.2272 23.3702 20.6136C23.3702 18.2108 21.3915 17.1569 18.9917 16.356C17.6024 15.8501 16.4236 15.5129 16.4236 14.459C16.4236 13.4473 17.5182 13.0258 18.6549 13.0258C19.9601 12.9414 21.3494 13.5316 22.2335 14.3325Z"
                                        fill="white"
                                    />
                                </svg>
                            )
                        }

                        <span>{modal.details.payment.tag}</span>
                    </div>
                </div>
                <div className="detail-line"></div>
                <div className="detail">
                    <div className="label">Amount</div>
                    <div className="value">${modal.details.payment.amount}</div>
                </div>
                <div className="detail">
                    <div className="label">Fee</div>
                    <div className="value">${modal.details.payment.fee}</div>
                </div>
                <div className="detail-line"></div>
                <div className="detail">
                    <div className="label">Total</div>
                    <div className="value total">${modal.details.payment.total}</div>
                </div>
            </div>

            <div className="modal-button blue" onClick={e => dispatch(closeModuleModal())}>Close</div>
        </Modal>
    )
}